/* eslint-disable no-unused-vars */
import PropTypes from 'prop-types';
import _ from 'lodash';

function findHighlightInString(str, highlight) {
  let escapedHighlight = highlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  // let trimmedHighlight = escapedHighlight.replace(/-/g, '').toLowerCase();
  let trimmedHighlight = escapedHighlight.toLowerCase();
  let regex = new RegExp(trimmedHighlight, 'i');
  let match = str.match(regex);
  return match ? match[0] : null;
}

const HighlightText = ({
  text = '',
  highlight = '',
  trim = false,
  onClick = null,
  dangerouslySetInnerHTML = false
}) => {
  let newHighLightText = highlight ? findHighlightInString(text, highlight) : '';

  const textNumberToString = text?.toString() || '';
  const value =
    textNumberToString &&
    (typeof textNumberToString === 'string'
      ? trim
        ? textNumberToString?.replace(/\s/g, '')?.toLowerCase()
        : textNumberToString?.toLowerCase()
      : '');

  const indexNum =
    newHighLightText?.trim() &&
    _.isString(newHighLightText?.trim()) &&
    value?.indexOf(newHighLightText?.trim().toLowerCase());

  function highlightHTML(html, searchTerm) {
    if (!searchTerm) return html;

    // Split search term into words & escape special characters
    const words = searchTerm
      .trim()
      .split(/\s+/)
      .map((word) => word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));

    if (words.length === 0) return html;

    // Match any of the words, ignoring case
    const regex = new RegExp(`(${words.join('|')})`, 'gi');

    // Use DOM parsing to avoid matching inside tags
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${html}</div>`, 'text/html');
    const container = doc.body.firstChild;

    function walk(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        // Replace only in text content
        const replaced = node.textContent.replace(
          regex,
          '<span style="background: #F9EDC7;">$1</span>'
        );
        if (replaced !== node.textContent) {
          const temp = document.createElement('span');
          temp.innerHTML = replaced;
          node.replaceWith(...temp.childNodes);
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        node.childNodes.forEach(walk);
      }
    }

    walk(container);

    return container.innerHTML;
  }

  return dangerouslySetInnerHTML ? (
    <span
      className="richText"
      dangerouslySetInnerHTML={{
        __html: highlightHTML(text, highlight)
      }}
    />
  ) : (
    <span onClick={onClick}>
      {indexNum >= 0 ? (
        <span>
          {_.isString(textNumberToString) && (
            <span>
              {trim
                ? textNumberToString?.substring(0, indexNum)
                : textNumberToString?.substring(0, indexNum)}
            </span>
          )}

          {_.isString(textNumberToString) &&
            !_.isEmpty(
              trim
                ? textNumberToString
                    ?.replace(/\s/g, '')
                    .substring(indexNum, indexNum + newHighLightText?.trim().length)
                : textNumberToString.substring(indexNum, indexNum + newHighLightText?.trim().length)
            ) && (
              <span style={{ background: '#F9EDC7' }}>
                {trim
                  ? textNumberToString.substring(
                      indexNum,
                      indexNum + newHighLightText?.trim().length
                    ) // Remove whitespace if 'trim' is true.
                  : textNumberToString.substring(
                      indexNum,
                      indexNum + newHighLightText?.trim().length
                    )}
              </span>
            )}

          {_.isString(textNumberToString) && (
            <span>
              {trim
                ? textNumberToString.substring(indexNum + newHighLightText?.trim().length)
                : textNumberToString.substring(indexNum + newHighLightText?.trim().length)}
            </span>
          )}
        </span>
      ) : (
        textNumberToString
      )}
    </span>
  );
};

HighlightText.propTypes = {
  text: PropTypes.any,
  newHighLightText: PropTypes.string
};

export default HighlightText;
